<template>
  <div class="main_footer_wrapper">
    <div class="suradnja_wrapper">
      <div class="suradnja_content">
        <h2>{{ $prismic.richTextAsPlain(suradnja_title) }}</h2>
        <p>{{ $prismic.richTextAsPlain(suradnja_description) }}</p>
        <div class="suradnja_buttons">
          <prismic-link target="_blank" :field="this.pdf_za_download">
            <div class="black_button header_button yellow_button">
                <span>{{ $prismic.richTextAsPlain(pdf_button_label) }}</span>
            </div>
          </prismic-link>
          <a href="mailto:info@showconcept.co">
            <div class="black_button header_button">
                <span>{{ $prismic.richTextAsPlain(upit_label) }}</span>
            </div> 
          </a>
        </div>         
      </div>
    </div><!-- end suradnja wrapper -->

    <div class="footer_wrapper">
      <div class="footer_left">
        <div class="footer_logo">
          <router-link :to="{ path:'/' }">
            <prismic-image :field="footer_logo"/>
          </router-link>
        </div>
        <div class="footer_title">
          {{ $prismic.richTextAsPlain(footer_title) }}
        </div>
        <div class="footer_address">
          <prismic-rich-text :field="footer_address"/>
        </div>
        <div class="footer_mail">
          <!-- <a :href="'mailto:'+footer_mail[0].text"> -->
          <a href="mailto:robert@showconcept.co">
            robert@showconcept.co
          </a>
        </div>
        <div class="footer_tel">
          {{ $prismic.richTextAsPlain(footer_tel) }}
        </div>
      </div><!-- end footer left -->

      <div class="footer_middle">
        <div class="footer_menu_wrapper"> 
          <div class="menu_items">
            <menus></menus>
          </div>
        </div> <!-- end menu wrapper -->
        <div class="footer_description">
          {{ $prismic.richTextAsPlain(footer_description) }}
        </div>
      </div><!-- end footer middle -->

      <div class="footer_right">
        <div class="footer_facebook">
          <img src="/facebook.svg">
        </div>
      </div>
    </div>
  </div><!-- end main footer wrapper -->
</template>

<script>
import Menus from './Menu.vue'

export default {
  name: 'Bottom',
    data () {
    return {
      //suradnja
      suradnja_title:null,
      suradnja_description:null,
      pdf_button_label:null,
      pdf_za_download:null,
      upit_label:null,
      //footer
      footer_logo:null,
      footer_title:null,
      footer_address:null,
      footer_mail:null,
      footer_tel:null,
      footer_description:null
    }
  },
  
  methods: {
    getContent () {
      //homepage general data
      this.$prismic.client.getSingle('footer')
        .then((document) => {
          if (document) {
            //suradnja
            this.suradnja_title = document.data.suradnja_title
            this.suradnja_description = document.data.suradnja_description
            this.pdf_button_label = document.data.pdf_button_label
            this.pdf_za_download = document.data.pdf_za_download
            this.upit_label = document.data.upit_label
            //footer
            this.footer_logo = document.data.footer_logo
            this.footer_title = document.data.footer_title
            this.footer_address = document.data.footer_address
            this.footer_mail = document.data.footer_mail
            this.footer_tel = document.data.footer_tel
            this.footer_description = document.data.footer_description
          } else {
            this.$router.push({ name: 'not-found' })
          }
        })
    },
  },
  mounted () {
    this.getContent();
  },
  components:{
    Menus
  } 
}
</script>